import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

export const loadStore: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { storeApi },
) =>
  action$.pipe(
    ofType(actions.STORE_ACTIONS.REQUESTED),
    switchMap(({ payload: { storeId } }) => {
      return storeApi.getStoreById(storeId).pipe(
        switchMap(({ store }) => of(actions.storeSucceeded(store))),
        catchError(error => of(actions.storeFailed(error))),
      );
    }),
  );



// WEBPACK FOOTER //
// ./src/scenes/Store/services/epics/loadStore.ts